module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_BlackMatted.7ce30758.jpg";